import { Injectable } from '@angular/core';
import { Angulartics2 } from 'angulartics2';

@Injectable({
    providedIn: 'root',
})
export class AnalyticsService {
    private readonly storageAttribute = 'sendAnalyticsData';

    constructor(private analytics: Angulartics2) {}

    changeTrackingState(state: boolean): void {
        localStorage.setItem(this.storageAttribute, state ? '1' : '0');
        this.analytics.settings.developerMode = !state;
    }

    getTrackingState(): boolean {
        return localStorage.getItem(this.storageAttribute) === '1';
    }

    private isDisabled(): boolean {
        return this.getTrackingState() === false;
    }

    trackEvent(payload): void {
        if (this.isDisabled()) {
            return;
        }
        this.analytics.eventTrack.next(payload);
    }
}
